module.exports = __webpack_public_path__ + "img/6-onebg.e238e4ed.jpg";